import React, { useContext, useEffect, useState } from 'react';
import { Tabs, TabsProps } from 'antd';

import ButtonCreateActivity from '@totem/components/ticketing/details/activities/buttonCreateActivity';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import TabTitle from '@totem/components/ui_components/tabs/TabTitle';
import NaActivities from '@totem/components/unauthenticated/ticketing/details/naActivities';
import PartiesInvolvedTable from '@totem/components/unauthenticated/ticketing/details/partyInvolved/naPartiesInvolvedTable';
import NaPartyInvolvedContext from '@totem/components/unauthenticated/ticketing/details/partyInvolved/naPartyInvolvedContext';
import NaTaskKanbanBoard from '@totem/components/unauthenticated/ticketing/details/tasks/naTaskKanbanBoard';
import { isNotNull, isNull } from '@totem/utilities/common';

const NaTicketTabs = () => {
  const { partyInvolved } = useContext(NaPartyInvolvedContext);
  const { ticket } = useContext(TicketContext);
  const [selectedTab, setSelectedTab] = useState<string>(
    !isNull(ticket) &&
      !isNull(ticket.ticket.tasks) &&
      ticket.ticket.tasks.length > 0 &&
      isNotNull(partyInvolved)
      ? 'Tasks'
      : 'Activity',
  );

  useEffect(() => {
    if (
      !isNull(ticket) &&
      !isNull(ticket.ticket.tasks) &&
      ticket.ticket.tasks.length > 0
    ) {
      setSelectedTab('Tasks');
    }
  }, [ticket, partyInvolved]);

  const updateSelectedTab = (newTab: string) => {
    setSelectedTab(newTab);
  };

  const getTabExtraContent = () => {
    switch (selectedTab) {
      case 'Activity':
        return <ButtonCreateActivity />;
      default:
        return null;
    }
  };

  const getTabItems = (): TabsProps['items'] => {
    const tabItems: TabsProps['items'] = [];

    if (
      !isNull(ticket) &&
      !isNull(ticket.ticket.tasks) &&
      ticket.ticket.tasks.length > 0 &&
      isNotNull(partyInvolved)
    ) {
      tabItems.push({
        key: 'Tasks',
        label: <TabTitle>Tasks</TabTitle>,
        children: <NaTaskKanbanBoard />,
      });
    }

    tabItems.push({
      key: 'Activity',
      label: <TabTitle>Activity</TabTitle>,
      children: <NaActivities />,
    });

    tabItems.push({
      key: 'PartiesInvolved',
      label: <TabTitle>Parties Involved</TabTitle>,
      children: <PartiesInvolvedTable ticket={ticket} />,
    });

    return tabItems;
  };

  return (
    <Tabs
      defaultActiveKey={getTabItems()[0].key}
      items={getTabItems()}
      onChange={(newKey) => updateSelectedTab(newKey)}
      tabBarExtraContent={getTabExtraContent()}
    />
  );
};

export default NaTicketTabs;
